/**
 * Laedt Videos mit der Klasse .sp-lazy-video erst dann, wenn es sich lohnt.
 *
 * Hintergrund: Die Startseite zog frueher ~18 MB Video beim ersten Aufruf,
 * weil mehrere <video autoplay preload="auto"> sofort komplett geladen haben.
 * Auf Mobilfunk hat das die Seite unbenutzbar gemacht.
 *
 * Regeln:
 *   - Datensparmodus aktiv  -> gar nicht laden, Poster bleibt stehen
 *   - Viewport < 769px      -> gar nicht laden, Poster bleibt stehen
 *   - sonst                 -> laden, sobald das Element in Sichtweite kommt
 *
 * Das Markup traegt die Quelle in data-src, damit der Browser sie nicht
 * von sich aus anfaesst.
 */
(function () {
  'use strict';

  var DESKTOP_MIN_WIDTH = '(min-width: 769px)';
  var ROOT_MARGIN = '200px';

  function prefersLessData() {
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    return Boolean(conn && conn.saveData);
  }

  function activate(video) {
    var src = video.getAttribute('data-src');
    if (!src || video.dataset.spLoaded) return;

    var source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    video.appendChild(source);

    video.dataset.spLoaded = '1';
    video.removeAttribute('data-src');
    video.load();

    var started = video.play();
    // Safari/iOS lehnen play() ohne Nutzerinteraktion teils ab. Das ist kein
    // Fehlerfall - dann bleibt schlicht das Poster stehen.
    if (started && typeof started.catch === 'function') {
      started.catch(function () {});
    }
  }

  function init() {
    var videos = document.querySelectorAll('.sp-lazy-video[data-src]');
    if (!videos.length) return;

    if (prefersLessData() || !window.matchMedia(DESKTOP_MIN_WIDTH).matches) return;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(videos, activate);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        activate(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: ROOT_MARGIN });

    Array.prototype.forEach.call(videos, function (video) {
      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
